import React from "react";

import ConversationHeader from "../../components/message/ConversationHeader";
import ConversationMessages from "../../components/message/ConversationMessages";
import MessageComposer from "../../components/message/MessageComposer";
import { useNavigate } from "react-router-dom";

export default function ConsultationConversation({

    request,
    messages = [],
    currentUser,
    reply,
    errors = {},
    loading = false,
    onReplyChange,
    onReplySubmit,
    onDownloadFile

}) {

const navigate = useNavigate();

const handleBack = () => {
    navigate(-0);
};

    if (!request) {





        return (
            <div className="card shadow-sm border-0">
                <div className="card-body text-center text-muted py-5">

                    <i
                        className="bi bi-chat-dots display-3 mb-3"
                    />

                    <h5>

                        Conversation indisponible

                    </h5>

                </div>

            </div>
        );

    }

    return (

        <div className="card shadow-sm border-0">

            {/*=========================================*/}
            {/* Header                                  */}
            {/*=========================================*/}

            <ConversationHeader
                request={request}
                nbMessages={messages.length}
            />

            {/*=========================================*/}
            {/* Corps                                   */}
            {/*=========================================*/}

            <div className="card-body p-0">
                {
                    messages.length === 0
                        ?
                        <div className="text-center py-5 text-muted">

                            <i
                                className="bi bi-chat-square-text display-4"
                            />

                            <h5 className="mt-3">

                                Aucun message

                            </h5>

                            <p>

                                Cette conversation ne contient encore aucun échange.

                            </p>

                        </div>

                        :

                        <ConversationMessages

                            messages={messages}

                            currentUser={currentUser}

                            onDownloadFile={onDownloadFile}

                        />

                }

            </div>

            {/*=========================================*/}
            {/* Footer                                  */}
            {/*=========================================*/}

            <div className="card-footer bg-light">

<MessageComposer
    consultationObject={request.consultationObject}
    message={reply}
    errors={errors}
    loading={loading}
    onChange={onReplyChange}
    onSubmit={onReplySubmit}
    onBack={handleBack}
/>
            </div>

        </div>

    );

}